import qs from 'qs'
import { BindCountLimitItem } from '@console/pages/Admin/MyService/SdkAccess/type'
import { deviceIsPublished } from '@/utils/device'
import request from '../../index'

const Global: any = global

interface IMyService {
  serviceItem: 0 | 1 // 0: 设备接入， 1: 服务接入
  type: 0 | 1 | 2 // 0：运动健康设备 1：IOT设备 2：预装应用
  pageNum: number
  pageSize: number
}

interface IDataAccessList {
  pageNum: number
  pageSize: number
}

interface IScope {
  id: string
  parentId: string
}

interface IDataAccess {
  appId?: string
  accessType?: 'PURCHASE' | 'DATAEXCHANGE' | 'SCIENCE'
  purchaseDescription?: string
  userDataLocation?: string
  saveDataLocation?: string
  dataPurpose?: string
  expiryTimestamp?: number
  dataItems?: Array<IScope>
  questionnaire?: string
}

interface IApplyAccess {
  accessType: 0 | 1 // 接入类型（设备接入） 0：蓝牙 1：NFC
  brand: string // 品牌
  businessArea: 0 | 1 // 0：医疗健康 1：其他
  cooperationIntention: string // 合作意向
  dataItem: string // 数据项
  developerId: string // 入驻Id
  preInstalledEquipment?: string // 预装设备
  referenceIntroduction: string // 引用介绍
  referenceName?: string // 应用名称
  serviceItem: 0 | 1 // 服务项 0:设备接入 1:服务接入
  type: 0 | 1 | 2 // 设备类型 0：运动健康设备 1：IOT设备 2：预装应用
}

export interface IDataReport {
  appId?: string
  startDate: string
  endDate: string
  pageNum: number
  pageSize: number
}

interface IDeleteAccess {
  serviceID: string
}

interface IServices {
  items: Array<{
    accessType: string
    brand: string
    businessArea: number
    cooperationIntention: string
    createTime: number
    dataItem: string
    developerId: string
    name: string
    preInstalledEquipment: string
    referenceIntroduction: string
    referenceName: string
    remarks: string
    serviceItem: number
    state: number
    type: number
    userId: string
  }>
  next: number
  pageNum: number
  pageSize: number
  total: number
}

interface MyAppList {
  pageNum: number
  pageSize: number
}

interface MyApp {
  appName: string // 应用名称
  appType: string // 应用类型 ["APP","WEB"]
  icon: string // 应用图标url
  authCallBackUrl: string // 授权回调地址
  dataCallBackUrl: string // 数据回调地址
  packageName?: string // 应用包名 (android)
  visitCallBackUrl?: string // 访问回调地址（服务器应用
  codeSignature?: string // 应用签名 (android)
  bundleId?: string // IOS bundleId
  authorizeType: Array<string> // 授权类型["IOS_SDK","ANDROID_SDK","WEB"]
}

export interface UpdateMyApp {
  appName?: string // 应用名称
  appNameEn?: string // 应用名称英文
  icon?: string // 应用图标url
  authCallBackUrl?: string // 授权回调地址
  dataCallBackUrl?: string // 数据回调地址
}

interface IBroadcastAccess {
  appType: string // 应用类型 ["APP","HARDWARE"]（移动 or 硬件）
  appName: string // 应用名称(广播申请无需先登记应用信息，应用名称为手动输入，与3类api数据接入的应用名称无关,应用名称64字上限)
  dataPurpose: string // 数据应用场景，字数上限255
}

interface ISdkAccess {
  appId: string // 接入应用id
  appType?: string // 目前只有移动应用["SDK"] 编辑时不需要传
  expiryTimestamp: number // 截止日期时间戳（毫秒）
  bindCountLimit: BindCountLimitItem[]
}

interface MyLightApp {
  userid: string // 用户 id
  app_name: string // 应用名称
  app_type: string // 应用类型
  icon: string // 应用图标
  description: string // 应用描述
}

interface MyLightAppList {
  userid: string // 用户 id
  pageNum: string
  pageSize: string
}

export interface UpdateMyLightApp {
  userid?: string // 用户 id
  app_name?: string
  name?: string // 应用名称
  app_type?: string // 应用类型
  icon?: string // 应用图标
  description?: string // 应用描述
  id?: number // 自增 id
}

const getParams = (params: any) => {
  let data = ''
  if (JSON.stringify(params) !== '{}') {
    Object.keys(params).forEach((key) => {
      data += `&${key}=${params[key]}`
    })
    data = `?${data.substring(1)}`
  }
  return data
}

// const mockHost = 'https://apihub.huami.com/mock/70/'

// 查询我接入的设备或服务
export function getMyService(params: IMyService): Promise<any> {
  const query = { pageNum: params.pageNum, pageSize: params.pageSize }
  return request(`${Global.hostConfig.zuul}v2/developer/service/${params.serviceItem}/${params.type}?${qs.stringify(query)}`)
}

// 申请接入
export function applyAccess(params: IApplyAccess): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/developer/service`, {
    method: 'post',
    data: params
  })
}

// 删除服务或设备
export function deleteAccess(params: IDeleteAccess): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/developer/service/${params.serviceID}`, {
    method: 'DELETE'
  })
}

// 获取用户信息
export function getMyInfo(): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/developer/account/center`)
}

// 获取认证信息
export function getAuthInfo(): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/developer`)
}

// 查询应用列表
export function getAppList(params: IDataAccessList): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/applications?${qs.stringify(params)}`)
}

// 查询接入申请列表
export function getDataAccessList(params: IDataAccessList): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/dataAccess/list?${qs.stringify(params)}`)
}

// 查询可申请数据项
export function getDataScopeList(accessType: 'PURCHASE' | 'DATAEXCHANGE' | 'SCIENCE'): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/dataAccess/getDataItems/${accessType}`)
}

// 查询可写入数据项 todo 接口未上线
export function getInputDataItems(): Promise<any> {
  // return Promise.resolve({});
  return request(`${Global.hostConfig.zuul}v2/dataService/dataAccess/getInputDataItems`)
}

// 申请数据接入
export function createDataAccess(params: IDataAccess): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/dataAccess`, {
    method: 'POST',
    data: params
  })
}

// 修改数据接入
export function updateDataAccess(id: string, params: IDataAccess): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/dataAccess/${params.accessType ? params.accessType : 'DATAEXCHANGE'}/${id}`, {
    method: 'PUT',
    data: params
  })
}

// 删除数据接入
export function deleteDataAccess(id: string, accessType: string): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/dataAccess/${accessType}/${id}`, {
    method: 'DELETE'
  })
}

// 查询数据接入申请
export function getDataAccessDetail(id: string, accessType: string): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/dataAccess/${accessType}/${id}`, {
    method: 'GET'
  })
}

// 查询数据报表
export function getDataReport(params: IDataReport): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataReport/dataService/query?${qs.stringify(params)}`, {
    method: 'GET'
  })
}

// 查询总用户数
export function getTotalUserCount(): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataReport/dataService/count`, {
    method: 'GET'
  })
}

// 获取我的应用列表
export function getMyAppList(params: MyAppList): Promise<any> {
  const { pageNum, pageSize } = params
  return request(`${Global.hostConfig.zuul}v2/dataService/applications?pageNum=${pageNum}&pageSize=${pageSize}`, {
    method: 'GET'
  })
}

// 应用登记
export function regApp(params: MyApp): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/applications`, {
    method: 'POST',
    data: params
  })
}

// 查询应用是否已登记
export function checkPackage(packageName: string): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/checkPackage/${packageName}`, {
    method: 'GET'
  })
}

// 获取应用详情
export function getAppDetail(id: string): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/applications/${id}`, {
    method: 'GET'
  })
}

// 下载图片
export function downloadPic(url: string): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/downloadPic?downloadPicUrl=${url}`, {
    method: 'GET'
  })
}

// 更新应用详情
export function updateApp(id: string, params: UpdateMyApp): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/applications/${id}`, {
    method: 'PUT',
    data: params
  })
}

// 删除数据接入
export function deleteApp(id: string): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/applications/${id}`, {
    method: 'DELETE'
  })
}

// 查询安全问卷
export function getQuestionnaire(accessType: 'PURCHASE' | 'DATAEXCHANGE' | 'SCIENCE'): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/dataAccess/questionnaire/${accessType}`, {
    method: 'GET'
  })
}

// 获取广播接入列表
export function getBroadcastAccessList(params: MyAppList): Promise<any> {
  const { pageNum, pageSize } = params
  return request(`${Global.hostConfig.zuul}v2/dataService/broadcastAccess/list?pageNum=${pageNum}&pageSize=${pageSize}`, {
    method: 'GET'
  })
}

// 广播申请接入
export function applyBroadcastAccess(params: IBroadcastAccess): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/broadcastAccess`, {
    method: 'POST',
    data: params
  })
}

// 删除广播数据接入
export function deleteBroadcastAccess(id: string): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/broadcastAccess/${id}`, {
    method: 'DELETE'
  })
}

// 获取 sdk 接入列表
export function getSdkAccessList(params: MyAppList): Promise<any> {
  const { pageNum, pageSize } = params
  return request(`${Global.hostConfig.zuul}v2/dataService/sdkAccess/list?pageNum=${pageNum}&pageSize=${pageSize}`, {
    method: 'GET'
  })
}

// 绑定设备列表查询
export function queryDevices(): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/sdkAccess/queryDevices`, {
    method: 'GET'
  })
}

// sdk 申请接入
export function applySdkAccess(params: ISdkAccess): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/sdkAccess`, {
    method: 'POST',
    data: params
  })
}

// 查询skd接入详情
export function getSdkAccessDetail(id: string, appType: string): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/sdkAccess/${appType}/${id}`, {
    method: 'GET'
  })
}

// 更新 sdk 接入详情
export function updateSdkAccess(appType: string, id: string, params: ISdkAccess): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/sdkAccess/${appType}/${id}`, {
    method: 'PUT',
    data: params
  })
}

// 删除sdk数据接入
export function deleteSdkAccess(id: string): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/sdkAccess/${id}`, {
    method: 'DELETE'
  })
}

// 查询实时数据申请项
export function getRealDataItems(): Promise<any> {
  return request(`${Global.hostConfig.zuul}v2/dataService/dataAccess/getRealDataItems`, {
    method: 'GET'
  })
}

// 获取轻应用列表
export function getMyLightAppList(params: MyLightAppList): Promise<any> {
  const { pageNum, pageSize, userid } = params
  return request(`${Global.hostConfig.userInfoHost}custom/app?page=${pageNum}&per_page=${pageSize}&userid=${userid}`, {
    method: 'GET'
  })
}

// 创建轻应用
export function regLightApp(params: MyLightApp, option?: any): Promise<any> {
  const { userid, ...restParams } = params
  return request(
    `${Global.hostConfig.userInfoHost}custom/app?userid=${userid}`,
    {
      method: 'POST',
      data: restParams
    },
    {
      needCatch: false,
      needVerifyToken: true,
      needVerifyExamine: true,
      ...option
    }
  )
}

// 编辑轻应用
export function updateLightApp(id: string, params: UpdateMyLightApp): Promise<any> {
  const { userid, ...restParams } = params
  return request(`${Global.hostConfig.userInfoHost}custom/app/${id}?userid=${userid}`, {
    method: 'PUT',
    data: restParams
  })
}

// 删除轻应用
export function deleteLightApp(id: string, userid: string): Promise<any> {
  return request(`${Global.hostConfig.userInfoHost}custom/app/${id}?userid=${userid}`, {
    method: 'DELETE'
  })
}

// 获取轻应用详情
export function getLightAppDetail(id: string, userid: string): Promise<any> {
  return request(`${Global.hostConfig.userInfoHost}custom/app/${id}?userid=${userid}`, {
    method: 'GET'
  })
}

// 获取轻应用版本信息
export function getLightAppVersionInfo(id: string): Promise<any> {
  return request(`${Global.hostConfig.apiWatch}app/package/${id}`, {
    method: 'GET'
  })
}

// 获取应用接入列表
export function getAuditList(params: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}custom/app/review/list${getParams(params)}`,
    {
      method: 'GET'
    },
    {
      needVerifyToken: true,
      needCatch: false,
      needVerifyExamine: true,
      ...option
    }
  )
}

// 获取应用接入详情
export function getAuditDetail(params: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}custom/app/${params.id}/review${getParams(params.params)}`,
    {
      method: 'GET'
    },
    {
      needCatch: true,
      needVerifyToken: true,
      needVerifyExamine: true,
      ...option
    }
  )
}

// 创建应用
export function createAuditApp(params: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}custom/app/${params.id}/review${getParams(params.params)}`,
    {
      method: 'POST',
      data: params.data
    },
    {
      needCatch: false,
      needVerifyToken: true,
      needVerifyExamine: true,
      ...option
    }
  )
}

// 编辑应用
export function editAuditApp(params: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}custom/app/${params.id}/review${getParams(params.params)}`,
    {
      method: 'PUT',
      data: params.data
    },
    {
      needCatch: false,
      needVerifyToken: true,
      needVerifyExamine: true,
      ...option
    }
  )
}

// 升级版本
export function updateAuditApp(params: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}custom/app/${params.id}/review/new${getParams(params.params)}`,
    {
      method: 'POST',
      data: params.data
    },
    {
      needCatch: false,
      needVerifyToken: true,
      needVerifyExamine: true,
      ...option
    }
  )
}

// 上传zab包
export function uploadZabPackage(params: any): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}custom/app/review/upload${getParams(params.params)}`,
    {
      method: 'POST',
      data: params.data
    },
    {
      needCatch: false,
      needVerifyToken: true,
      needVerifyExamine: false
    }
  )
}

// 上传图片和pdf文件
export function uploadFile(params: any): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}custom/app/review/upload/meta${getParams(params.params)}`,
    {
      method: 'POST',
      data: params.data
    },
    {
      needCatch: false,
      needVerifyToken: true,
      needVerifyExamine: false
    }
  )
}

// 应用名称重复查询
export function checkNameExist(params: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}custom/app/review/check-name${getParams(params)}`,
    {
      method: 'GET'
    },
    {
      needCatch: true,
      needVerifyToken: true,
      needVerifyExamine: true,
      ...option
    }
  )
}

// 查询设备的元信息
export function getDeviceInfo(params: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}device/settings/meta${getParams(params)}`,
    {
      method: 'GET'
    },
    {
      needCatch: true,
      needVerifyToken: true,
      needVerifyExamine: true,
      ...option
    }
  ).then(devicesInfo => {
    if (Array.isArray(devicesInfo)) {
      return devicesInfo.map(deviceInfo => {
        // 添加 deviceNameForUser 字段，已发售使用产品名称（productNameEN）, 未发售使用代号（code）
        const { productNameEN, productName, code, releaseDate = '' } = deviceInfo
        const isPublished = deviceIsPublished(releaseDate)

        return {...deviceInfo, productName: isPublished ? (productNameEN || productName) : code}
      })
    }

    return devicesInfo
  })

}

// 获取表盘分类
export function getWatchfaceType(params: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}custom/app/review/category${getParams(params)}`,
    {
      method: 'GET'
    },
    {
      needCatch: true,
      needVerifyToken: true,
      needVerifyExamine: true,
      ...option
    }
  )
}

// 付费档位查询
export function getAppPrice(params: any): Promise<any> {
  return request(`${Global.hostConfig.userInfoHost}custom/app/review/price`, {
    method: 'GET',
    params: {
      userid: params.userid,
      devices: params.devices,
      app_type: params.appType || 1 // 1 表盘, 2 应用。默认表盘
    }
  }).then(res => {
    let data = res?.data
    // hide paid level 1
    if (Array.isArray(data)) {
      data = res.data.filter((item: any) => item.product_level !== 1)

      return {
        ...res,
        data,
      }
    }

    return res
  })
}

// 获取数据看板
export function getMarketStatistics(params: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}market/open/statistics${getParams(params)}`,
    {
      method: 'GET'
    },
    {
      needVerifyToken: true,
      needCatch: false,
      needVerifyExamine: true,
      ...option
    }
  )
}

// 获取表盘/应用支持设备列表
export function getSupportDeviceList(params: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}custom/app/review/devices?userid=${params.userid}&app_type=${params.app_type}`,
    {
      method: 'GET'
    },
    {
      needCatch: false,
      needVerifyToken: true,
      needVerifyExamine: true,
      ...option
    }
  )
}

// 获取用户提审次数
export function getUserSubmitCounts(userid: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}custom/app/review/counts?userid=${userid}`,
    {
      method: 'GET'
    },
    {
      needCatch: false,
      needVerifyToken: true,
      needVerifyExamine: false,
      ...option
    }
  )
}

// 查询用户签署协议状态
export function queryUserAgreementState(userid: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}custom/app/review/statement?userid=${userid}`,
    {
      method: 'GET'
    },
    {
      needCatch: false,
      needVerifyToken: true,
      needVerifyExamine: false,
      ...option
    }
  )
}

// 获取付费支持设备和国家列表
export function getPayRegionOrDevice(params: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}market/open/app/setting?userid=${params.userid}`,
    {
      method: 'GET'
    },
    {
      needCatch: false,
      needVerifyToken: true,
      needVerifyExamine: true,
      ...option
    }
  )
}

// 获取显示菜单，如是否支持付费
export function getDisplayMenu(params: any, option: any = {}): Promise<any> {
  const { userid, country, region, userType  } = params || {}
  const newParams: any = {
    userid,
    user_country: country,
    user_region: region,
  }

  if (userType || userType === 0) {
    newParams.user_type = userType
  }

  return request(
    `${Global.hostConfig.userInfoHost}market/open/display-menu`,
    {
      method: 'GET',
      params: newParams,
    },
    {
      needCatch: false,
      needVerifyToken: true,
      needVerifyExamine: false,
      ...option
    }
  )
}

// 更新应用名称
export function updateAppName(params: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}custom/app/${params.id}?userid=${params.userid}`,
    {
      method: 'PUT',
      data: {
        name: params.appName,
        app_type: params.appType
      }
    },
    {
      needCatch: false,
      needVerifyToken: true,
      needVerifyExamine: true,
      ...option
    }
  )
}

// 撤回审核中应用
export function withdrawReview(params: any, option: any = {}): Promise<any> {
  return request(
    `${Global.hostConfig.userInfoHost}custom/app/${params.id}/review/withdraw?userid=${params.userid}`,
    {
      method: 'POST'
    },
    {
      needCatch: false,
      needVerifyToken: true,
      needVerifyExamine: true,
      ...option
    }
  )
}
